module.exports = __webpack_public_path__ + "static/media/025.9a46e8ea.jpg";